import { createSelector } from 'reselect';
import { isAppAuthSelector } from './AuthSelectors';
export const requiredOnboardingSelector = state => {
  const {
    requiredOnboarding
  } = state;
  return requiredOnboarding;
};
export const productInventorySelector = ({
  productInventory
}) => productInventory;
export const productDataSelector = ({
  abstractedProducts
}) => {
  return abstractedProducts;
};
export const gatesSelector = state => {
  if (isAppAuthSelector(state)) {
    const {
      auth: {
        gates,
        user: {
          scopes = []
        }
      }
    } = state;
    return [...gates, ...scopes];
  }
  return [];
};
export const transformState = createSelector(
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore ignore the error where useSelector is limited to 12 selectors
[productDataSelector, requiredOnboardingSelector, gatesSelector, productInventorySelector], (productData, requiredOnboarding, gates, productInventory) => ({
  productData,
  requiredOnboarding,
  gates,
  productInventory
}));